import Seo from "../Components/Seo.jsx";
import PageHeader from "../Components/PageHeader.jsx";
import ContactUs from "../Components/ContactUs.jsx";
import { VenueCard, ContactLines } from "../Components/SiteInfo.jsx";
import { ORG } from "../seo/site.js";

const PATH = "/contact/";

const Contact = () => (
  <>
    <Seo path={PATH} />
    <PageHeader
      title="Contact Us and Find Our Venue"
      breadcrumbs={[
        { label: "Home", href: "/", icon: "bi-house" },
        { label: "Contact and Venue", active: true },
      ]}
    />

    <section className="py-5">
      <div className="container py-lg-4">
        <div className="row g-4 align-items-stretch">
          <div className="col-lg-6">
            <h2 className="fw-bold mb-3">Talk to us</h2>
            <p className="text-muted">
              Questions about classes, levels, fees or enrolment? Call or email
              us, or send a message using the form below.
            </p>
            <ContactLines />
            <p className="text-muted mt-4 mb-0">
              You can also message the committee on{" "}
              <a
                href={ORG.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="red-text fw-semibold"
              >
                WhatsApp
                <span className="visually-hidden"> (opens in a new tab)</span>
              </a>
              .
            </p>
          </div>
          <div className="col-lg-6">
            <VenueCard className="h-100" />
          </div>
        </div>
      </div>
    </section>

    <section className="py-5" style={{ background: "#f9f9f9" }}>
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-5">
            <h2 className="fw-bold mb-3">Class times and visiting</h2>
            <p className="text-muted">
              Classes run outside mainstream school hours at {ORG.venue.name}.
              Class times and term dates are confirmed each year, so please
              contact us for the current timetable.
            </p>
            <p className="text-muted mb-0">
              Visiting for the first time? Ask us about arrival, parking and
              access arrangements, and we will help you find your way.
            </p>
          </div>
          <div className="col-lg-7">
            <div className="ratio ratio-4x3 rounded-4 overflow-hidden border">
              <iframe
                src={ORG.mapsEmbedUrl}
                title="Map of Walters Road Public School, 158 Walters Road, Blacktown"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ContactUs showTitle={false} />
  </>
);

export default Contact;
